import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';

const PricingPage = () => {
  const pricingPlans = [
    {
      name: 'First Session',
      price: 'FREE',
      period: 'trial session',
      description: 'Try San Kai Karate with no commitment',
      features: [
        'Full 2-hour training session',
        'Experience our teaching style',
        'Meet our instructor Paul Rees',
        'No obligation to continue',
        'All equipment provided'
      ],
      color: 'green',
      popular: false
    },
    {
      name: 'Regular Session',
      price: '£6',
      period: 'per 2-hour session',
      description: 'Excellent value for quality karate training',
      features: [
        '2 hours of expert instruction',
        'Friday evening sessions',
        'All skill levels welcome',
        'Pay as you go flexibility',
        'Build fitness and confidence',
        'Learn traditional karate'
      ],
      color: 'red',
      popular: true
    },
    {
      name: 'Free School Holiday Training',
      price: 'FREE',
      period: 'during half-term breaks',
      description: 'New students train for FREE during school half-term holidays',
      features: [
        'Free training every half-term break',
        'For new students only',
        'Keeps kids active during the holidays',
        'Perfect way to get started',
        'Then just £6 per session',
        'Ask Paul about the next half-term'
      ],
      color: 'green',
      popular: false
    }
  ];

  return (
    <div className="page-wrapper pricing-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">Membership Pricing</h1>
          <p className="page-subtitle">
            Choose the membership option that best fits your training goals. All prices in British Pounds (£).
          </p>
        </div>
      </div>

      <div className="container">
        <div className="pricing-grid">
          {pricingPlans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.popular ? 'popular' : ''}`}>
              {plan.popular && (
                <div className="popular-badge">Most Popular</div>
              )}
              <div className="pricing-header">
                <h3 className="pricing-plan-name">{plan.name}</h3>
                <div className="pricing-amount">
                  <span className="price">{plan.price}</span>
                  <span className="period">{plan.period}</span>
                </div>
                <p className="pricing-description">{plan.description}</p>
              </div>
              <ul className="pricing-features">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="pricing-feature">
                    <Check size={20} className="feature-check" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <Link to="/contact" className={`btn-pricing ${plan.color}`}>
                Get Started
              </Link>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="pricing-info">
          <div className="info-card">
            <h3 className="info-title">What's Included</h3>
            <p className="info-text">
              All memberships include access to our modern dojo facilities, professional instruction from certified black belt instructors, 
              and a welcoming community of martial artists. We provide a safe, supportive environment for students of all ages and abilities.
            </p>
          </div>
          <div className="info-card">
            <h3 className="info-title">Free Trial Available</h3>
            <p className="info-text">
              Not sure if karate is right for you? We offer a free trial class for all new students. 
              Experience our teaching style and meet our instructors before committing to a membership.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;